export default __webpack_public_path__ + "static/media/fullscreenIcon.8fdb9b5d.svg";